

const addnewproject = [
  
  {
    id: 1,
    image:
      "https://i.ibb.co/ZNDmn5c/karina-jpg.png",
    name: "Karina Reid  - Candidate for Richmond City Council",
    meaning:
      "Web design and develoment for a candidate running for Richmond City Council in B.C., Canada",
      website: "http://www.karinareid.ca",
  },
  
  {

    
    id: 2,
    image:
      "https://i.ibb.co/sWsCGpP/asc.png",
    name: "Ascension Sciences Inc.",
    meaning:
      "Comprehensive design and website audit using HTML, CSS and Javascript in Wordpress",
    website: "http://www.ascensionsciences.com",
  },
  {

    id: 3,
    image:
      "https://i.ibb.co/mXB5gDj/notes.png",
    name: "A note taking app",
    meaning: "Created with React.js this app allows users to create, keep and delete daily notes.",
    website: "https://thingstodotoday.netlify.app/",
  },
  {
    id: 4,
    image:
      "https://i.ibb.co/1fjNh3v/Screenshot-2021-02-05-194356.png",
    name: "My Personal Website",
    meaning: "Designed and coded with UX/UI in mind, I developed this website using React.js",
    website: "https://www.mjawebdesigns.com/",
  },
  
];

export default addnewproject;
